<template>
  <div class="tw-w-modal">
    <div class="tw-border-b tw-border-border-light tw-p-6">
      <h2 class="tw-text-xl tw-font-bold tw-text-black">
        Do you want to send a conversion request?
      </h2>
    </div>
    <div
      v-if="error"
      class="tw-border-b tw-border-gray-500 tw-bg-red tw-p-6 tw-text-sm tw-text-white"
    >
      {{ error }}
    </div>
    <div class="tw-flex tw-items-center tw-justify-between tw-p-6">
      <PassportButton
        variant="basic"
        label="Cancel"
        @@click="$emit('close')"
      />
      <PassportButton
        :busy="isLoading"
        type="button"
        variant="primary"
        :label="error ? 'Ok' : 'Send Conversion Request'"
        @@click="handleSubmit"
      />
    </div>
  </div>
</template>

<script>
import PassportButton from '@/components/PassportButton.vue'

export default {
  name: 'PopupOrderFlightConvert',
  components: { PassportButton },
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  emits: ['close'],

  data() {
    return {
      isLoading: false,
      shouldRetry: false,
      error: '',
    }
  },

  methods: {
    async handleSubmit() {
      if (this.error) {
        this.$emit('close')
        return
      }

      this.error = ''
      this.isLoading = true

      try {
        await this.$store.dispatch('orderFlight/requestConversion', {
          id: this.item.id,
        })
        await this.$store.dispatch('orderFlight/fetch', {
          id: this.item.id,
          reload: true,
        })

        this.$store.dispatch('addToast', {
          type: 'info',
          value: `Conversion request sent`,
        })

        this.$emit('close')
      } catch (error) {
        if (error.response?.data?.errors?.length) {
          this.error = error.response.data.errors[0].message
        } else if (error.message) {
          this.error = error.message
        } else {
          this.error =
            "An error occurred, we couldn't proceed with your conversion request. Please try again later. (Only a Sales person is allowed to do so)"
        }
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
